import React from 'react';
import type { IconProps } from '../types';

/**
 * Astra custom toolbar mode icons — both draw with `currentColor` so they
 * inherit the toolbar's themed (active / inactive) colour automatically.
 *
 *  - CardiacHeart       → the "MRI Advanced" cardiac workspace button
 *  - VolumeRenderingVrt → the "3D Volume Rendering" (VRT) workspace button
 *
 * VRT gets a rendered-volume-in-a-box glyph so it is clearly DIFFERENT from the
 * plain isometric cubes used by the MPR / 3D-MPR layout buttons (`icon-mpr-cube`,
 * `icon-volume-cube`), which previously shared a look with VRT.
 */

/** Heart with a small ECG pulse — the MRI-Advanced cardiac workspace. */
export const CardiacHeart = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <title>cardiac-heart</title>
    <path d="M12 20.3 C12 20.3 3.6 14.6 3.6 8.9 C3.6 6.2 5.7 4.3 8.1 4.3 C9.8 4.3 11.3 5.3 12 6.8 C12.7 5.3 14.2 4.3 15.9 4.3 C18.3 4.3 20.4 6.2 20.4 8.9 C20.4 14.6 12 20.3 12 20.3 Z" />
    <path
      d="M6.2 12.1 H9 L10.3 9.6 L12.1 14.4 L13.4 12.1 H17.8"
      strokeWidth="1.3"
    />
  </svg>
);

/** A shaded rendered volume inside its bounding box — 3D Volume Rendering (VRT). */
export const VolumeRenderingVrt = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <title>vrt</title>
    {/* faint bounding volume box */}
    <path
      d="M12 2.6 L20.5 7.3 L20.5 16.7 L12 21.4 L3.5 16.7 L3.5 7.3 Z"
      strokeOpacity="0.55"
    />
    <path
      d="M3.5 7.3 L12 12 M20.5 7.3 L12 12 M12 12 L12 21.4"
      strokeOpacity="0.3"
    />
    {/* the rendered volume */}
    <circle
      cx="12"
      cy="12.6"
      r="3.9"
      fill="currentColor"
      fillOpacity="0.9"
      stroke="none"
    />
  </svg>
);

export default CardiacHeart;
